import { cva } from 'class-variance-authority'
import { cn } from '~/lib/utils'

import TertiaryLink from '~/components/UI/Buttons/TertiaryLink/TertiaryLink'

const cardVariants = cva(
  'relative flex max-h-[500px] !h-[500px] flex-col p-xs-plus sm:basis-[calc(50%-12px)] sm:p-s lg:grow lg:basis-0 lg:p-m gap-s',
  {
    variants: {
      backgroundColour: {
        'ink-blue': 'bg-blue-d text-white',
        'mid-blue': 'bg-blue-m text-white',
        chartreuse: 'bg-char text-blue-d',
        'light-grey': 'bg-grey-l text-blue-d',
        white: 'bg-white text-blue-d'
      }
    },
    defaultVariants: {
      backgroundColour: 'ink-blue'
    }
  }
)

export type CourseCardProps = CardProps & {
  content: {
    tag: string
    code?: string
    points?: string
  }
}

const CourseCard = ({ content, className, carousel }: CourseCardProps) => {
  const { backgroundColour, heading, tag, copy, code, points, buttons } =
    content
  const button = buttons ? buttons[0] : null

  const foregroundColour = ['ink-blue', 'mid-blue'].includes(backgroundColour)
    ? 'white'
    : 'ink-blue'

  return (
    <div className={cn(cardVariants({ backgroundColour }), className)}>
      <div className='gap-xs-plus flex grow flex-col'>
        <h3 className={cn(carousel ? 'line-clamp-3' : 'line-clamp-4')}>
          {heading}
        </h3>
        <p
          className={cn(
            'tag',
            foregroundColour === 'white' ? 'text-white' : 'text-blue-m'
          )}
        >
          {tag}
        </p>
        <p
          className={cn(
            carousel
              ? code || points
                ? 'line-clamp-2'
                : 'line-clamp-3'
              : 'line-clamp-7'
          )}
        >
          {copy}
        </p>
        {(code || points) && (
          <div
            className={cn(
              'gap-xs flex items-center',
              foregroundColour === 'white' ? 'text-white' : 'text-blue-m'
            )}
          >
            {code && <p className='tag'>{code}</p>}
            {points && (
              <p
                className={cn(
                  'tag pl-xs border-l',
                  foregroundColour === 'white'
                    ? 'border-white'
                    : 'border-blue-m'
                )}
              >
                {points} UCAS points
              </p>
            )}
          </div>
        )}

        {button && (
          <div className='flex w-fit grow items-end'>
            <TertiaryLink data={button} colour={foregroundColour} />
          </div>
        )}
      </div>
    </div>
  )
}

export default CourseCard
